export default {
  $validator: (value) => {
    return value === true;
  },
  // $message: 'test cool'
};
